import { render, staticRenderFns } from "./RiskBadge.html?vue&type=template&id=3c4b9458&external"
import script from "./RiskBadge.vue?vue&type=script&lang=js"
export * from "./RiskBadge.vue?vue&type=script&lang=js"
import style0 from "./RiskBadge.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports